export default "__VITE_ASSET__T7Dei9TP__"